var Alabama = "アラバマ";
var Alaska = "アラスカ";
var Arizona = "アリゾナ";
var Arkansas = "アーカンソー";
var California = "カリフォルニア";
var Colorado = "コロラド";
var Connecticut = "コネチカット";
var Delaware = "デラウェア";
var Florida = "フロリダ";
var Georgia = "ジョージア";
var Hawaii = "ハワイ";
var Idaho = "アイダホ";
var Illinois = "イリノイ";
var Indiana = "インディアナ";
var Iowa = "アイオワ";
var Kansas = "カンザス";
var Kentucky = "ケンタッキー";
var Louisiana = "ルイジアナ";
var Maine = "メイン";
var Maryland = "メリーランド";
var Massachusetts = "マサチューセッツ";
var Michigan = "ミシガン";
var Minnesota = "ミネソタ";
var Mississippi = "ミシシッピ";
var Missouri = "ミズーリ";
var Montana = "モンタナ";
var Nebraska = "ネブラスカ";
var Nevada = "ネバダ";
var Ohio = "オハイオ";
var Oklahoma = "オクラホマ";
var Oregon = "オレゴン";
var Pennsylvania = "ペンシルバニア";
var Tennessee = "テネシー";
var Texas = "テキサス";
var Utah = "ユタ";
var Vermont = "バーモント";
var Virginia = "バージニア";
var Washington = "ワシントン";
var Wisconsin = "ウィスコンシン";
var Wyoming = "ワイオミング";
var USStates = {
	Alabama: Alabama,
	Alaska: Alaska,
	Arizona: Arizona,
	Arkansas: Arkansas,
	California: California,
	Colorado: Colorado,
	Connecticut: Connecticut,
	Delaware: Delaware,
	"District of Columbia (DC)": "コロンビア特別区 (DC)",
	Florida: Florida,
	Georgia: Georgia,
	Hawaii: Hawaii,
	Idaho: Idaho,
	Illinois: Illinois,
	Indiana: Indiana,
	Iowa: Iowa,
	Kansas: Kansas,
	Kentucky: Kentucky,
	Louisiana: Louisiana,
	Maine: Maine,
	Maryland: Maryland,
	Massachusetts: Massachusetts,
	Michigan: Michigan,
	Minnesota: Minnesota,
	Mississippi: Mississippi,
	Missouri: Missouri,
	Montana: Montana,
	Nebraska: Nebraska,
	Nevada: Nevada,
	"New Hampshire": "ニューハンプシャー",
	"New Jersey": "ニュージャージー",
	"New Mexico": "ニューメキシコ",
	"New York": "ニューヨーク",
	"North Carolina": "ノースカロライナ",
	"North Dakota": "ノースダコタ",
	Ohio: Ohio,
	Oklahoma: Oklahoma,
	Oregon: Oregon,
	Pennsylvania: Pennsylvania,
	"Rhode Island": "ロードアイランド",
	"South Carolina": "サウスカロライナ",
	"South Dakota": "サウスダコタ",
	Tennessee: Tennessee,
	Texas: Texas,
	Utah: Utah,
	Vermont: Vermont,
	Virginia: Virginia,
	Washington: Washington,
	"West Virginia": "ウェストバージニア",
	Wisconsin: Wisconsin,
	Wyoming: Wyoming
};

export { Alabama, Alaska, Arizona, Arkansas, California, Colorado, Connecticut, Delaware, Florida, Georgia, Hawaii, Idaho, Illinois, Indiana, Iowa, Kansas, Kentucky, Louisiana, Maine, Maryland, Massachusetts, Michigan, Minnesota, Mississippi, Missouri, Montana, Nebraska, Nevada, Ohio, Oklahoma, Oregon, Pennsylvania, Tennessee, Texas, Utah, Vermont, Virginia, Washington, Wisconsin, Wyoming, USStates as default };
